import { render, staticRenderFns } from "./reclot.vue?vue&type=template&id=21405788&scoped=true&"
import script from "./reclot.vue?vue&type=script&lang=js&"
export * from "./reclot.vue?vue&type=script&lang=js&"
import style0 from "./reclot.vue?vue&type=style&index=0&id=21405788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21405788",
  null
  
)

export default component.exports